<script lang="ts">
import {defineComponent} from 'vue'
import LeftMenu from "@/components/ContactPerson/Layout/LeftMenu.vue"
import PageWithLeftMenu from "@/components/Global/Layout/PageWithLeftMenu.vue"

export default defineComponent({
  name: "StudentContainerView",
  components: {
    PageWithLeftMenu,
    LeftMenu,
  },
})
</script>

<template>
  <PageWithLeftMenu>
    <template #left_menu>
      <LeftMenu></LeftMenu>
    </template>
  </PageWithLeftMenu>
</template>